import React from 'react';
import PropTypes from 'prop-types';
import { Popup as SemanticPopup } from 'semantic-ui-react';

/**
 * Custom Popup implementation to support a delayed trigger
 */
class Popup extends React.Component {
  static propTypes = {
    openDelay: PropTypes.number,
    closeDelay: PropTypes.number,
    onClose: PropTypes.func,
    onOpen: PropTypes.func,
    open: PropTypes.bool,
    on: PropTypes.oneOf(['hover', 'click', 'focus']),
  };

  static defaultProps = {
    openDelay: 0,
    closeDelay: 0,
    onClose: (e, data) => {},
    onOpen: (e, data) => {},
    open: false,
    on: 'hover',
  };

  openDelayTimer = null;
  closeDelayTimer = null;

  state = {
    open: this.props.open,
  };

  componentWillUnmount() {
    clearTimeout(this.openDelayTimer);
    clearTimeout(this.closeDelayTimer);
  }

  onOpen = (e, data) => {
    const { openDelay } = this.props;
    this.openDelayTimer = setTimeout(() => {
      this.setState({ open: true }, () => {
        this.props.onOpen(e, data);
      });
    }, openDelay);

    clearTimeout(this.closeDelayTimer);
  };

  onClose = (e, data) => {
    const { closeDelay, onClose } = this.props;
    this.closeDelayTimer = setTimeout(() => {
      this.setState({ open: false });
      onClose(e, data);
    }, closeDelay);
    clearTimeout(this.openDelayTimer);
  };

  render() {
    const { openDelay, closeDelay, ...rest } = this.props;
    const { open } = this.state;
    return (
      <SemanticPopup
        {...rest}
        onOpen={this.onOpen}
        onClose={this.onClose}
        open={open}
      />
    );
  }
}

export { Popup };



// WEBPACK FOOTER //
// ./src/common/Components/Popup/Popup.js